import React from 'react';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import './buttons.css';

export const Button = (props) => {
  const { theme, content, onClick } = props;
  const cls = `btn ${theme ? theme : ''}`;
  return <button className={cls} onClick={onClick}>{content}</button>;
}

export const ButtonLink = (props) => {
  const { theme, content, to } = props;
  const __theme = `${theme ? theme : ''} btn-link`;
  const __content = <NavLink smooth to={to}>{content}</NavLink>;
  return<Button theme={__theme} content={ __content} />;
}
